import React, { useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2"; // SweetAlert import

function VerifyadOtp() {
  const [otp, setOtp] = useState("");

  const location = useLocation();
  const navigate = useNavigate();

  const email = location.state?.email;

  const verifyOtp = async (e) => {
    e.preventDefault();

    if (!email) {
      Swal.fire({
        icon: "warning",
        title: "Session Expired",
        text: "Email not found! Please go back to forgot password.",
        confirmButtonColor: "#f39c12",
      });
      navigate("/forgetpas");
      return;
    }

    try {
      await axios.post("https://uniformnx-com.onrender.com/user/verify-otp", {
        email,
        otp,
      });

      Swal.fire({
        icon: "success",
        title: "Verified!",
        text: "OTP Verified successfully",
        timer: 1500,
        showConfirmButton: false,
      });

      navigate("/reset-password", { state: { email } }); 
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Invalid OTP",
        text: err.response?.data?.message || "Please check the code and try again.",
        confirmButtonColor: "#d33",
      });
    }
  };

  return (
    <div
      style={{
        textAlign: "center",
        padding: "50px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundImage:
          "url(https://png.pngtree.com/background/20210709/original/pngtree-cartoon-education-training-cram-school-picture-image_917042.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="col-11 col-md-5">
        <form
          onSubmit={verifyOtp}
          className="form-control p-5 shadow"
          style={{
            background: "rgba(255,255,255,0.2)",
            backdropFilter: "blur(10px)",
            border: "none",
          }}
        >
          <h2 className="text-white mb-4">Verify OTP</h2>
          
          <p className="text-white-50 mb-4">
            Enter the 6-digit code sent to: <br />
            <strong className="text-white">{email || "your email"}</strong>
          </p>

          <input
            type="text"
            className="form-control mb-4 text-center mx-auto w-75"
            placeholder="Enter OTP"
            required
            onChange={(e) => setOtp(e.target.value)}
          />

          <button 
            type="submit" 
            className="animated-btn btn border-1 w-75 border-light text-light"
          >
            <span>Verify OTP</span>
          </button>

          <div className="mt-4">
            <button 
              type="button"
              onClick={() => navigate(-1)} 
              className="btn btn-link text-white text-decoration-none"
              style={{ fontSize: "0.9rem" }}
            >
              ← Back
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default VerifyadOtp;